export const ASSIGNMENT_TEST_TYPES = {
    STDIN: {
        value: 1,
        name: 'Stdin',
    },
    FUNCTION_IN: {
        value: 2,
        name: 'Function In',
    },
    FRAMEWORK: {
        value: 3,
        name: 'Framework',
    },
}
